'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
var style = require('../../../transformers/style.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Wrapper = styled__default["default"].div.withConfig({
  componentId: "sc-o9exm7-0"
})(["margin-top:2rem;display:flex;flex-direction:column;align-self:stretch;align-items:center;justify-content:center;text-align:center;padding:1.5rem;background-color:#f7f7f7;border:1px solid #cccccc;gap:1rem;", ";"], _ref => {
  let {
    theme
  } = _ref;
  return {
    borderRadius: style.getBorderRadius(theme.panelcontainerNoneNone, 4),
    borderWidth: style.getBorderWidth(theme.panelcontainerNoneNone) ?? 1
  };
});
const FormField = styled__default["default"].div.withConfig({
  componentId: "sc-o9exm7-1"
})(["width:100%;max-width:312px;text-align:left;"]);
const Disclaimer = styled__default["default"].div.withConfig({
  componentId: "sc-o9exm7-2"
})(["", ";font-style:italic;color:#999999;"], _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.captiontextDefaultNone;
});
const ErrorMessage = styled__default["default"].div.withConfig({
  componentId: "sc-o9exm7-3"
})(["padding-top:0.5rem;", ";"], _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.captiontextErrorNone;
});

exports.Disclaimer = Disclaimer;
exports.ErrorMessage = ErrorMessage;
exports.FormField = FormField;
exports.Wrapper = Wrapper;
